import Styled from 'styled-components';

const Container = Styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e9e9e9;
  border-radius: 12px;
  margin-left: 26px;
  width: 100%;
  height: fit-content;
  padding-bottom: 20px;
`;

const AuxiliaryTitleWrapper = Styled.div`
  border-radius: 12px 12px 0 0;
  background-color: #fafafa;
  padding: 15px 26px;
  width: 100%;
  border-bottom: 1px solid #e9e9e9;
`;

const NoCommentsStyled = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px 0 12px 0;

  & b {
    font-size: 24px;
  }
  & p {
    font-size: 16px;
  }
`;

const Link = Styled.a`
  cursor: pointer;
  color: ${({ theme }) => theme.primaryColor};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: bold;
  line-height: 14px;
  text-transform: ${({ theme }) => theme.btnTextTransform};
`;

export default NoCommentsStyled;
export { Container, AuxiliaryTitleWrapper, NoCommentsStyled, Link };
